import React from 'react';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';
import ContentHeader from './ContentHeader';

/**
 * Wraps standalone report pages (e.g. ClientsReport, ClientStatusQuickEdit)
 * with ContentHeader including back link to Reports hub.
 * No title - the child report (e.g. DataGrid) provides its own.
 */
function ReportPageWrapper({ children }) {
  const { tenantPath } = useTenantFromUrl();
  return (
    <>
      <ContentHeader
        backTo={tenantPath('/reports')}
        backLabel="Back to Reports"
      />
      {children}
    </>
  );
}

export default ReportPageWrapper;
